// extracted by mini-css-extract-plugin
export default {"SavedViewsList":"SidebarLoading-module__SavedViewsList--N0QWP","LoadingViewsList":"SidebarLoading-module__LoadingViewsList--xhYOf"};